import { observer } from 'mobx-react-lite'
import './index.scss'
import XImg from '@assets/svg/x.svg'
import { LoginPage } from '@Pages/LoginPage'
import { Context } from '@/index'
import { useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { register as registerApi } from '@api/user-api'

// --------------------------------
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
// --------------------------------
const validationSchema = Yup.object().shape({
 first_name: Yup.string()
  .required('Adı daxil edin')
  .min(2, 'Ad ən azı 2 simvoldan ibarət olmalıdır'),
 last_name: Yup.string()
  .required('Soyadı daxil edin')
  .min(2, 'Soyad ən azı 2 simvoldan ibarət olmalıdır'),
 radio: Yup.string().required('Rol seçin').nullable(true),
 email: Yup.string()
  .email('Düzgün email daxil edin')
  .required('Email daxil edin'),
 password: Yup.string()
  .required('Parolu daxil edin')
  .min(6, 'Parol ən azı 6 simvoldan ibarət olmalıdır'),
 password2: Yup.string()
  .required('Parolu daxil edin')
  .min(6, 'Parol ən azı 6 simvoldan ibarət olmalıdır'),
 t_and_c: Yup.bool().oneOf([true], 'Razılıq tələb olunur'),
})

const formOptions = { resolver: yupResolver(validationSchema) }

const RegisterPage = observer(() => {
 const { modal, userStore } = useContext(Context)
 const [isUniqueEmailError, setIsUniqueEmailError] = useState(false)
 const [isDifferentPasswordsError, setIsDifferentPasswordsError] =
  useState(false)
 const {
  register,
  handleSubmit,
  formState: { errors },
 } = useForm(formOptions)

 const onSubmit = ({
  first_name,
  last_name,
  radio,
  email,
  password,
  password2,
 }) => {
  console.log(radio)
  if (password !== password2) {
   setIsDifferentPasswordsError(true)
   return
  }
  if (radio === 'freelancer') {
   userStore.setIsFreelancer(true)
  } else {
   userStore.setIsFreelancer(false)
  }
  registerApi(email, password, first_name, last_name)
   .then((res) => {
    console.log(res)
    userStore.fetchUser()
    modal.closeModal()
    //   setIsLoading(false)
    //   setIsSubmitted(true)
    //   userStore.setUser(res.data.user)
    //   userStore.setIsAuth(true)
    //   history.push('/')
   })
   .catch((error) => {
    console.log(error)
    setIsUniqueEmailError(true)
    //   setIsLoading(false)
    //   setIsSubmitted(false)
   })
 }

 return (
  <div className="register-page">
   <div className="header-modal">
Platformanın üzvü olun 😎
    <div className="x-block" onClick={() => modal.closeModal()}>
     <img src={XImg} className="x" />
    </div>
   </div>
   <form className="form" onSubmit={handleSubmit(onSubmit)}>
    <div className="form-control-block">
     <label className="form-label">Zəhmət olmasa özünüzü təqdim edin</label>
     <div className="row">
      <div className="col-md-6">
       <input
        type="text"
        className="form-control"
        placeholder="Məsələn, Pərviz"
        {...register('first_name')}
       />
       {errors.first_name?.message && (
        <p className="error">{errors.first_name?.message}</p>
       )}
      </div>
      <div className="col-md-6 gap-for-inputs">
       <input
        type="text"
        className="form-control"
        placeholder="Məsələn, Əliyev"
        {...register('last_name')}
       />
       {errors.last_name?.message && (
        <p className="error">{errors.last_name?.message}</p>
       )}
      </div>
     </div>
    </div>
    <div className="form-control-block">
     <label className="form-label">Rol seçin</label>
     <div className="radios">
      <div className="form-check">
       <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault1"
        {...register('radio')}
        value="manager"
       />
       <label className="form-check-label" htmlFor="flexRadioDefault1">
        Sifarişçi
       </label>
      </div>
      <div className="form-check second-radio">
       <input
        className="form-check-input"
        type="radio"
        name="flexRadioDefault"
        id="flexRadioDefault2"
        {...register('radio')}
        value="freelancer"
       />
       <label className="form-check-label" htmlFor="flexRadioDefault2">
        Freelancer
       </label>
      </div>
      {errors.radio?.message && (
       <p className="error">{errors.radio?.message}</p>
      )}
     </div>
     <div className="gray-text">
      Qeydiyyatdan sonra hesab növünüzü dəyişə bilərsiniz
     </div>
    </div>
    <div className="form-control-block">
     <label htmlFor="email" className="form-label">
      İş ünvanı olaraq hansı ünvanı istifadə etmək lazımdır?
     </label>
     <input
      type="text"
      className={`form-control ${isUniqueEmailError && 'input-error'}`}
      id="email"
      placeholder="Məsələn, petrov@yandex.ru"
      {...register('email')}
      onFocus={() => setIsUniqueEmailError && setIsUniqueEmailError(false)}
     />
     {errors.email?.message && <p className="error">{errors.email?.message}</p>}
     {isUniqueEmailError && (
      <p className="error">🤔 Bu elektron poçt ünvanı artıq istifadə olunur</p>
     )}
    </div>
    <div className="form-control-block">
     <label htmlFor="email" className="form-label">
      Parol
     </label>
     <div className="row">
      <div className="col-md-6">
       <input
        type="password"
        className="form-control"
        placeholder="Parol düşünün"
        {...register('password')}
        onFocus={() =>
         isDifferentPasswordsError && setIsDifferentPasswordsError(false)
        }
       />
       {errors.password?.message && (
        <p className="error">{errors.password?.message}</p>
       )}
       {isDifferentPasswordsError && (
        <p className="error">😢 Parollar uyğun olmalıdır</p>
       )}
      </div>
      <div className="col-md-6 gap-for-inputs">
       <input
        type="password"
        className={`form-control ${isDifferentPasswordsError && 'input-error'}`}
        placeholder="Parolu təsdiq edin"
        {...register('password2')}
        onFocus={() =>
         isDifferentPasswordsError && setIsDifferentPasswordsError(false)
        }
       />
       {errors.password2?.message && (
        <p className="error">{errors.password2?.message}</p>
       )}
      </div>
     </div>
    </div>
    <div className="form-check">
     <input
      className="form-check-input"
      type="checkbox"
      value="true"
      id="flexCheckDefault"
      {...register('t_and_c')}
     />
     <label className="form-check-label" htmlFor="flexCheckDefault">
      Şəxsi məlumatların{' '}
      <a href="/policy" target="_blank" className="underline">
       emalına
      </a>{' '}
      və{' '}
      <a href="/terms" target="_blank" className="underline">
       istifadəçi razılaşmasına
      </a>{' '} uyğun olaraq razılığınız lazımdır
     </label>
     {errors.t_and_c?.message && (
      <p className="error">{errors.t_and_c?.message}</p>
     )}
    </div>
    <div className="invalid-feedback">Bütün sahələri doldurduğunuzu yoxlayın</div>
    <button type="submit" className="my-button first-button">
     Qeydiyyatdan keç
    </button>
    <button
     type="button"
     className="my-button second-button"
     onClick={() => modal.showModal(<LoginPage />)}
    >
     Artıq platformanın üzvüyəm 😶
    </button>
   </form>
  </div>
 )
})

export { RegisterPage }
